import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Parameter } from '../components/interface'

export interface parametersState {
  isLoading: boolean
  loadingError: string | null
  modbusParameters: Parameter[] | null
  httpStatus: number | null
}

export const initialState: parametersState = {
  isLoading: true,
  loadingError: null,
  modbusParameters: null,
  httpStatus: null
}

const modbusParamsSlice = createSlice({
  name: 'modbusParameters',
  initialState,
  reducers: {
    modbusParamsLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        modbusParameters: null,
        httpStatus: 0
      }
    },
    modbusParamsUpdateAction: (state, action: PayloadAction<{ data: Parameter[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        modbusParameters: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    modbusParamsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        modbusParameters: null,
        httpStatus: action.payload.httpStatus
      }
    },
    modbusParamsReset: () => initialState
  }
})

export const {
  modbusParamsLoadingAction,
  modbusParamsUpdateAction,
  modbusParamsErrorAction,
  modbusParamsReset
} = modbusParamsSlice.actions

export default modbusParamsSlice.reducer
